import { MessageCircle } from 'lucide-react';

export default function FloatingCta() {
  return (
    <a className="floating-cta" href="#kapcsolat" aria-label="Ingyenes konzultáció kérése">
      <MessageCircle size={20} />
      <span>Kérdezz bátran</span>
    </a>
  );
}
